<template>
  <button
    @click="$router.push('/write')"
    aria-label="글쓰기"
    class="float-button"
  >
    <i class="xi-plus" aria-hidden="true"></i>
  </button>
</template>
